import {$, w} from './constants';

export function tooltipInit() {
	let $activeTooltip = null;

	function createTooltip($btn) {
		const tooltipText = $btn.data('tooltip');
		if (!tooltipText) return;

		// Cierra tooltip anterior si existe
		if ($activeTooltip) $activeTooltip.remove();

		// Crea el tooltip oculto para calcular medidas reales
		const $tooltip = $(`
			<div class="floating-tooltip" style="visibility:hidden;">
				<div class="tooltip-content">${tooltipText}</div>
				<div class="tooltip-arrow"></div>
			</div>
		`);

		const customClass = $btn.data('class');
		if (customClass) {
			$tooltip.addClass(customClass);
		}

		$('body').append($tooltip);

		// Forzar reflow para obtener medidas reales
		$tooltip[0].offsetHeight;

		const offset = $btn.offset();
		const btnWidth = $btn.outerWidth();
		const tooltipWidth = $tooltip.outerWidth();
		const tooltipHeight = $tooltip.outerHeight();
        // Elimina clases previas
        $tooltip.removeClass('align-left align-right');

        // Márgenes y medidas
        const margin = 16;
        const viewportWidth = $(window).width();

        let top = offset.top - tooltipHeight - 10;
        let left = offset.left + btnWidth / 2 - tooltipWidth / 2;

        // Aplica solo en mobile
        if (viewportWidth <= 768) {
            // Limpiar clases anteriores
            $tooltip.removeClass('align-left align-right');

            // Limitar ancho máximo para dejar margen visual
            const maxAllowedWidth = viewportWidth - (margin * 2);
            $tooltip.css('max-width', maxAllowedWidth + 'px');

            // Recalcular ancho real después de limitarlo
            const newTooltipWidth = $tooltip.outerWidth();

            // Verifica si se sale por la derecha
            if (left + newTooltipWidth > viewportWidth - margin) {
                left = viewportWidth - newTooltipWidth - margin;
                $tooltip.addClass('align-left');

            // Si se sale por la izquierda
            } else if (left < margin) {
                left = margin;
                $tooltip.addClass('align-right');
            }
        } else {
            // En desktop: quitar clases, mantener centrado y resetear ancho
            $tooltip.removeClass('align-left align-right');
            $tooltip.css('max-width', '400px');
        }

        // Aplicar posición final
        $tooltip.css({
			top: top + 'px',
			left: left + 'px',
			visibility: 'visible'
		});

        $activeTooltip = $tooltip;
	}

	// Hover para desktop
	$('.tooltip--btn').on('mouseenter', function () {
		if (window.innerWidth > 951) {
			createTooltip($(this));
		}
	});

	$('.tooltip--btn').on('mouseleave', function () {
		if (window.innerWidth > 951 && $activeTooltip) {
			$activeTooltip.remove();
			$activeTooltip = null;
		}
	});

	// Click para mobile
	$('.tooltip--btn').on('click', function (e) {
		e.stopPropagation(); // Previene que se cierre de inmediato

		// Si ya está activo y vuelven a hacer click, lo quitamos
		if ($activeTooltip) {
			$activeTooltip.remove();
			$activeTooltip = null;
			return;
		}

		createTooltip($(this));
	});

	// Cierra el tooltip si haces clic en cualquier otro lado
	$(document).on('click touchstart', function () {
		if ($activeTooltip) {
			$activeTooltip.remove();
			$activeTooltip = null;
		}
	});
}

export function tooltipInitTippy() {
	
	const isMobile = window.innerWidth <= 950;

	tippy('.tooltip--btn', {
		content(reference) {
			return reference.getAttribute('data-tooltip') || '';
		},
		arrow: true,
		placement: 'top',
		theme: 'gbm',
		trigger: isMobile ? 'click' : 'mouseenter focus',
		interactive: true, // Para que no se cierre al hacer clic dentro
		appendTo: document.body,
		allowHTML: true,
	});
}